import React from 'react';
import Hero from './components/sports-gallery/Hero';
import Main from './components/sports-gallery/Main';


const SportsGallery = () => {
  return (
    <div>
        <Hero/>
        <Main/>
    </div>
  )
}

export default SportsGallery;